import { HTTPService, httpService } from "../../services/http.service"
import { NewsListDO } from "../data/news.data"

export class News {
  private startDate: string
  private endDate: string

  constructor(private httpService: HTTPService) {
    this.startDate = new Date(Date.now() - 1000 * 60 * 60 * 24 * 30).toISOString().split('T')[0]
    this.endDate = new Date().toISOString().split('T')[0]
  }

  async load():Promise<NewsListDO> {
    const params = new URLSearchParams()
    params.set('start_date', this.startDate)
    params.set('end_date', this.endDate)

    return await this.httpService.query(`news/etf?${params}`, "GET")
  }
}

export const newsService = new News(httpService)